export default "__VITE_ASSET__jnMu77Y6__"